import type { ImageProps } from '@mantine/core';
import { Image, useMantineColorScheme } from '@mantine/core';
import type { EntityType } from '@repo/common/enums/entityType';
import s3Svg from '@repo/common/public/images/logos/integrations/s3.svg';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';
import { useIntegrationPrefetched } from '../../api';
import { getIconByEntityType } from '../../utils/integrationLogo';

interface IIntegrationLogo extends ImageProps {
	entityType?: EntityType;
	integrationType?: string;
	integrationId?: string;
	size?: number;
	iconOverride?: any;
}

function IntegrationLogo({
	entityType,
	integrationId,
	integrationType,
	iconOverride,
	...props
}: IIntegrationLogo) {
	const { data: integration } = useIntegrationPrefetched({
		id: integrationId!,
		options: {
			enabled: !isNil(integrationId) && integrationId !== 'secoda',
		},
	});
	const { colorScheme } = useMantineColorScheme();

	let width = '32px';
	let height = '32px';

	const { width: propsWidth, height: propsHeight, size: propsSize } = props;

	if (propsSize) {
		width = `${propsSize}px`;
		height = `${propsSize}px`;
	} else if (typeof propsWidth === 'number') {
		width = `${propsWidth}px`;
		height = `${propsWidth}px`;
	} else if (typeof propsHeight === 'number') {
		width = `${propsHeight}px`;
		height = `${propsHeight}px`;
	}

	const { icon: Icon } = useMemo(
		() =>
			getIconByEntityType(
				entityType,
				integration,
				integration?.type ?? integrationType,
				colorScheme === 'dark'
			),
		[entityType, integration, integrationType, colorScheme]
	);

	if (iconOverride && iconOverride === 's3.svg') {
		return (
			<Image
				{...props}
				src={s3Svg}
				width={width}
				height={height}
				fit="contain"
			/>
		);
	}

	return (
		<Icon {...(props as any)} width={width} height={height} fit="contain" />
	);
}

export default IntegrationLogo;
